// A gentle nudge for people who have no account (so no automatic online backup): remind them to save a backup file.
export const DAY_MS = 86400000;
export const LAST_BACKUP_KEY = "bb-last-backup";
const NUDGE_KEY = "bb-backup-nudge";

export function recordBackup(now = Date.now()) { try { localStorage.setItem(LAST_BACKUP_KEY, String(now)); } catch (e) { /* ignore */ } }
export function lastBackupAt() { try { return Number(localStorage.getItem(LAST_BACKUP_KEY)) || 0; } catch (e) { return 0; } }

// Remind if the last backup is more than `staleDays` old (or there never was one), and we haven't already nudged within `quietDays`.
export function backupReminderDue({ lastBackup, lastNudge, now = Date.now(), staleDays = 30, quietDays = 7 }) {
  const stale = !lastBackup || now - lastBackup > staleDays * DAY_MS;
  const quiet = !!lastNudge && now - lastNudge < quietDays * DAY_MS;
  return stale && !quiet;
}

// Call once when the app opens. Returns true (and remembers it) if a reminder should be shown now.
export function takeBackupReminder(now = Date.now()) {
  try {
    const due = backupReminderDue({ lastBackup: lastBackupAt(), lastNudge: Number(localStorage.getItem(NUDGE_KEY)) || 0, now });
    if (due) localStorage.setItem(NUDGE_KEY, String(now));
    return due;
  } catch (e) { return false; }
}
